import { useTranslation } from 'react-i18next'
import { YeekeeLottoCardProps } from './YeekeeLottoCard.types'
import { useThemeAssets } from '../../hooks/useThemeAssets'
import { useThemeFeatures } from '../../hooks/useThemeFeatures'
import LottoCardFlagHeader from '../LottoCardFlagHeader'
import LottoResultsDivider from '../LottoResultsDivider'
import styles from './YeekeeLottoCard.module.css'

const YeekeeLottoCard: React.FC<YeekeeLottoCardProps> = ({
  country,
  flagBackgroundName,
  title,
  rounds,
}) => {
  const { t } = useTranslation()
  const { backgroundFlagImageUrls, smallFlagImageUrls } = useThemeAssets()
  const themeFeatures = useThemeFeatures()

  return (
    <div
      className={`yeekee-lotto-result-card rounded-2xl ${styles.card}`}
      style={{
        backgroundImage: `url(${backgroundFlagImageUrls[flagBackgroundName]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className={`p-4 ${styles.cardInner}`}>
        <div
          className={`yeekee-lotto-card-bg rounded-xl ${styles.content} py-6 pl-6 pr-0 text-[var(--yeekee-text-color)]`}
        >
          {/* Header */}
          <LottoCardFlagHeader
            title={title}
            country={country}
            imageMap={smallFlagImageUrls}
            variant="yeekee"
          />

          {/* Results Divider - Only show in blue theme */}
          {themeFeatures.yeekeeShowResultsDivider && (
            <LottoResultsDivider
              label={t('lottoCard.results')}
              variant="yeekee"
            />
          )}

          {/* Table */}
          <div className="w-full">
            <div
              className={`max-h-[300px] overflow-y-auto legacy-scrollbar pr-4 ${styles.tableContainer}`}
            >
              <table className="w-full text-sm md:text-base">
                <thead className="sticky top-0 yeekee-table-header">
                  <tr className="bg-transparent">
                    <th
                      className="p-3 w-1/3 text-left"
                      style={{ color: 'var(--yeekee-header-color)' }}
                    >
                      {t('lottoCard.round')}
                    </th>
                    <th
                      className="p-3 w-1/3 text-center whitespace-nowrap"
                      style={{ color: 'var(--yeekee-header-color)' }}
                    >
                      {t('betDetailPanel.betLottoType.bet_three_top')}
                    </th>
                    <th
                      className="p-3 w-1/3 text-center whitespace-nowrap"
                      style={{ color: 'var(--yeekee-header-color)' }}
                    >
                      {t('betDetailPanel.betLottoType.bet_two_under')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {rounds.map((round, idx) => (
                    <tr
                      key={idx}
                      className="border"
                      style={{ borderColor: 'var(--yeekee-border-color)' }}
                      onClick={round.onClick}
                    >
                      <td
                        className="px-4 py-1 font-bold w-1/3 whitespace-nowrap"
                        style={{ color: 'var(--yeekee-text-color)' }}
                      >
                        {round.round}
                      </td>
                      <td className="px-4 py-1 w-1/3">
                        <div className="flex justify-center gap-1">
                          {round.threeTop.map((num, i) => (
                            <h4
                              key={i}
                              className="text-2xl font-bold min-w-[1rem] text-center"
                              style={{ color: 'var(--yeekee-text-color)' }}
                            >
                              {num}
                            </h4>
                          ))}
                        </div>
                      </td>
                      <td className="px-4 py-1 w-1/3">
                        <div className="flex justify-center gap-1">
                          {round.twoUnder.map((num, i) => (
                            <h4
                              key={i}
                              className="text-2xl font-bold min-w-[1rem] text-center"
                              style={{ color: 'var(--yeekee-text-color)' }}
                            >
                              {num}
                            </h4>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default YeekeeLottoCard
